//noinspection JSUnresolvedFunction

adminRoutes.$inject = ["$stateProvider"];

var main_url = require("./templates/main.html");
var clinic_relationships_url = require("./templates/clinic-relationships.html");
let fax_url = require("./templates/fax-referral.html");
let fax_edit_url = require("./templates/fax-referral-edit.html");
let fax_index_url = require("./templates/fax-referral-index.html");
let menu_url = require("./templates/menu.html");
let profile_url = require("./templates/profile.html");
let api_key_url = require("./templates/api-key.html");
let pharmacist_url = require("./templates/pharmacist.html");
let pharmacist_edit_url = require("./templates/pharmacist-edit.html");
let referral_url = require("./templates/referral.html");
let referral_all_url = require("./templates/referral-all.html");
let referral_edit_url = require("./templates/referral-edit.html");
let referral_view_url = require("./templates/referral-view.html");
let upload_url = require("./templates/upload.html");
let user_url = require("./templates/user.html");
let user_roles_url = require("./templates/user-roles.html");

export default function adminRoutes($stateProvider) {
  // TODO When changing Twig to AngularJS, remove `target="_self"` from links in HMRX_App/scripts/src/admin/templates/partials/menu.html
  $stateProvider
    .state("admin", {
      url: "/admin",
      templateUrl: main_url,
      resolve: {
        data: function (AdminService) {
          return AdminService.load_admin_data();
        },
        roles: function (AdminService) {
          return AdminService.load_roles();
        },
      },
      controller: "AdminController",
      controllerAs: "adminCtrl",
    })
    .state("admin.login", {
      // TODO This should be `url: "/login"`. Remove `/admin` when updating this path to AngularJS
      url: "/admin/login",
      // TODO Replace `main_url` with `admin_url`
      templateUrl: main_url,
      // TODO Replace `AdminController` with `LoginController`
      controller: "AdminController",
      controllerAs: "adminCtrl",
    })
    .state("admin.profile", {
      templateUrl: menu_url,
      params: {
        title: "Profile",
        menu_tab: "profile",
      },
      controller: "MenuController",
      controllerAs: "menuCtrl",
    })
    .state("admin.profile.index", {
      url: "/profile",
      templateUrl: profile_url,
      controller: "ProfileController",
      controllerAs: "profileCtrl",
    })
    .state("admin.clinic", {
      url: "/clinic/{clinic_id:\\d+}",
      templateUrl: menu_url,
      params: {
        title: "Clinics",
        menu_tab: "clinic",
      },
      controller: "MenuController",
      controllerAs: "menuCtrl",
    })
    .state("admin.clinic.api-key", {
      url: "/api-key",
      templateUrl: api_key_url,
      params: {
        title: "Clinic API Key",
        menu_tab: "clinic",
      },
      resolve: {
        clinic: function (AdminService, $stateParams) {
          return AdminService.load_clinic($stateParams.clinic_id);
        }
      },
      controller: "ClinicController",
      controllerAs: "clinicCtrl",
    })
    .state("admin.clinic.relationships", {
      url: "/relationships",
      templateUrl: clinic_relationships_url,
      resolve: {
        relationships: function (ClinicRelationshipsService, $stateParams) {
          return ClinicRelationshipsService.load($stateParams.clinic_id);
        },
      },
      controller: "ClinicRelationshipController",
      controllerAs: "relationshipCtrl",
    })
    .state("admin.pharmacists", {
      templateUrl: menu_url,
      params: {
        title: "Pharmacists",
        menu_tab: "pharmacist",
      },
      controller: "MenuController",
      controllerAs: "menuCtrl",
    })
    .state("admin.pharmacists.pharmacist-all", {
      url: "/pharmacist",
      templateUrl: pharmacist_url,
      resolve: {
        data: function (AdminPharmacistService) {
          return AdminPharmacistService.load_all();
        },
      },
      controller: "AdminPharmacistController",
      controllerAs: "pharmacistCtrl",
    })
    .state("admin.pharmacists.pharmacist-edit", {
      url: "/pharmacist/{id:\\d+}",
      templateUrl: pharmacist_edit_url,
      resolve: {
        data: function (AdminPharmacistService, $stateParams) {
          return AdminPharmacistService.load_one($stateParams.id);
        },
      },
      controller: "AdminPharmacistEditController",
      controllerAs: "pharmacistEditCtrl",
    })
    .state("admin.referrals", {
      templateUrl: menu_url,
      params: {
        title: "Referrals",
        menu_tab: "referral",
      },
      controller: "MenuController",
      controllerAs: "menuCtrl",
    })
    .state("admin.referrals.referral", {
      url: "/referral",
      templateUrl: referral_url,
      resolve: {
        data: function (ReferralService) {
          return ReferralService.no_data();
        },
      },
      controller: "ReferralController",
      controllerAs: "referralCtrl",
    })
    .state("admin.referrals.referral.all", {
      url: "/all",
      templateUrl: referral_all_url,
      resolve: {
        data: function (ReferralService) {
          return ReferralService.max_id();
        },
      },
      controller: "ReferralController",
      controllerAs: "referralCtrl",
    })
    .state("admin.referrals.referral.view", {
      url: "/{hmr_id:[A-Z]*\\d+}",
      templateUrl: referral_view_url,
      resolve: {
        data: function (ReferralService, $stateParams) {
          return ReferralService.get_hmr($stateParams.hmr_id);
        },
      },
      controller: "ReferralController",
      controllerAs: "referralCtrl",
    })
    .state("admin.referrals.referral.edit", {
      url: "/{hmr_id:[A-Z]*\\d+}/edit",
      templateUrl: referral_edit_url,
      resolve: {
        data: function (ReferralService, $stateParams) {
          return ReferralService.get_hmr($stateParams.hmr_id);
        },
      },
      controller: "ReferralController",
      controllerAs: "referralCtrl",
    })
    .state("admin.referrals.referral.file-upload", {
      url: "/upload-extra-file",
      templateUrl: upload_url,
      controller: "FileUploadController",
      controllerAs: "fileUploadCtrl",
    })
    .state("admin.referrals.referral.file-download", {
      url: "/download-extra-file/{file:\\d+}",
    })
    .state("admin.referrals.referral.fax", {
      url: "/fax",
      templateUrl: fax_url,
      resolve: {
        data: function (ReferralService) {
          return ReferralService.load_fax();
        },
      },
      controller: "FaxDataController",
      controllerAs: "faxDataCtrl",
    })
    .state("admin.referrals.referral.fax.index", {
      url: "/all",
      templateUrl: fax_index_url,
      controller: "FaxController",
      controllerAs: "faxCtrl",
    })
    .state("admin.referrals.referral.fax.edit", {
      url: "/{id:[A-Z]*\\d+}",
      templateUrl: fax_edit_url,
      controller: "FaxController",
      controllerAs: "faxCtrl",
    })
    .state("admin.users", {
      templateUrl: menu_url,
      params: {
        title: "Users",
        menu_tab: "user",
      },
      controller: "MenuController",
      controllerAs: "menuCtrl",
    })
    .state("admin.users.user", {
      url: "/user",
      templateUrl: user_url,
      controller: "UserController",
      controllerAs: "userCtrl",
    })
    .state("admin.users.user.roles", {
      url: "/roles",
      templateUrl: user_roles_url,
      resolve: {
        data: function (UserService) {
          return UserService.load();
        },
      },
      controller: "UserDataController",
      controllerAs: "userDataCtrl",
    })
  ;
}



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/admin/admin.routes.js
 **/